<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Order No：{{ formData.orderNo }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Package Plan No：{{ formData.mrpPackagePlanNo }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge style="font-size: 12px" 
          :variant="
            formData.planStatus === 'N' 
              ? 'success'
              : formData.planStatus === 'D'
              ? 'warning'
              : formData.planStatus === 'C' ||
                formData.planStatus === 'P' ||
                formData.planStatus === 'T'
              ? 'danger'
              : 'primary'
          ">
          {{ formData.v_planStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName ? formData.modifyByName : '--' }} at
          {{ formData.modifyDate ? formData.modifyDate : '--' }}
        </span>
      </div>
    </div>
    <div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        :disabled="true"
        size="small"
      >
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_mrpPackagePlanNo') || '客户订单编号'"
              prop="mrpFabricPlanNo"
            >
              <el-input
                v-model="formData.mrpPackagePlanNo"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_custOrderNo') || '客户订单编号'
              "
              prop="custOrderNo"
            >
              <el-input
                v-model="formData.custOrderNo"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.order_form_label_custCode') || '客户名称'"
              prop="custName"
            >
              <el-input
                v-model="formData.custName"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_endCustCode') || '终端客户名称'
              "
              prop="endCustName"
            >
              <el-input
                v-model="formData.endCustName"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_salesPersonCode') || '业务人员名字'
              "
              prop="salesPersonName"
            >
              <el-input
                v-model="formData.salesPersonName"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderType') || '订单类型'"
              prop="v_orderType"
            >
              <el-input
                v-model="formData.v_orderType"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.order_form_label_orderSource') || '订单来源'"
              prop="v_orderSource"
            >
              <el-input
                v-model="formData.v_orderSource"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="
                $l('INDEX.order_form_label_orderExecuteType') || '执行方式'
              "
              prop="v_orderExecuteType"
            >
              <el-input
                v-model="formData.v_orderExecuteType"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.order_form_label_scmCode') || '执行工厂名称'"
              prop="scmName"
            >
              <el-input
                v-model="formData.scmName"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.order_form_label_reviewTime') || '订单审核时间'"
              prop="orderReviewTime"
            >
              <el-date-picker
                v-model="formData.orderReviewTime"
                type="datetime"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_needKindCount') || '包装需求种类'"
              prop="needKindCount"
            >
              <el-input
                v-model="formData.needKindCount"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_hasKindCount') || '已采购种类'"
              prop="hasKindCount"
            >
              <el-input
                v-model="formData.hasKindCount"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_stockKindCount') || '已入库种类'"
              prop="stockKindCount"
            >
              <el-input
                v-model="formData.stockKindCount"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_needTotalQty') || '总需求数量'"
              prop="needTotalQty"
            >
              <el-input
                v-model="formData.needTotalQty"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_hasKTotalQty') || '已采购总数'"
              prop="hasKTotalQty"
            >
              <el-input
                v-model="formData.hasKTotalQty"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_stockTotalQty') || '已入库总数'"
              prop="stockTotalQty"
            >
              <el-input
                v-model="formData.stockTotalQty"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.table_label_created_by') || '创建人'"
              prop="createByName"
            >
              <el-input
                v-model="formData.createByName"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.table_label_created_date') || '创建时间'"
              prop="createDate"
            >
              <el-date-picker
                v-model="formData.createDate"
                type="datetime"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.table_label_modified_by') || '修改人'"
              prop="modifyByName"
            >
              <el-input
                v-model="formData.modifyByName"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.table_label_modification_date') || '修改时间'"
              prop="modifyDate"
            >
              <el-date-picker
                v-model="formData.modifyDate"
                type="datetime"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.order_form_label_reviewByName') || '审核人'"
              prop="reviewByName"
            >
              <el-input
                v-model="formData.reviewByName"
                type="text"
                clearable
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('INDEX.order_form_label_reviewTime') || '审核时间'"
              prop="reviewTime"
            >
              <el-date-picker
                v-model="formData.reviewTime"
                type="datetime"
                size="small"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    mrpPackagePlanCode: String,
  },
  data() {
    return {
      formData: {},
      rules: {},
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.mrpPackagePlanCode) return
      this.$api
        .mrpPackagePlanDetailApi({
          mrpPackagePlanCode: this.mrpPackagePlanCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
